import React, { useState, useRef } from 'react';
import ViewModal from 'ui/components/shared/ViewModal';
import styles from './UploaderContainer.styles';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import UploadFileIcon from '@mui/icons-material/UploadFile';

const UploaderContainer = ({ sx, disabled, onChangeFile }) => {
  const { t } = useTranslation();
  const dragCounter = useRef(0);
  const [file, setFile] = useState(null);
  const [isDrag, setIsDrag] = useState(false);
  const fileInputRef = useRef(null);
  const [isHover, setIsHover] = useState(false);

  const handleFileChange = (event) => {
    const newFile = event.target.files[0];
    if (newFile) {
      onChangeFile(newFile);
      setFile(newFile);
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDragEnter = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (disabled) return;

    dragCounter.current++;
    if (dragCounter.current === 1) {
      setIsDrag(true);
    }
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (disabled) return;

    dragCounter.current--;
    if (dragCounter.current === 0) {
      setIsDrag(false);
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (disabled) return;

    const newFile = event.dataTransfer.files[0];
    if (newFile) {
      onChangeFile(newFile);
      setFile(newFile);
    }
    dragCounter.current = 0;
    setIsDrag(false);
  };

  const handleClick = () => {
    if (disabled) return;
    fileInputRef.current.click();
  };

  const style = {
    ...styles.container,
    ...(isDrag && !disabled ? styles.dragContainer : {}),
    ...(isHover && !disabled ? styles.hoverContainer : {}),
    ...(disabled ? styles.disabledContainer : {}),
    ...sx,
  };

  return (
    <div
      style={style}
      onDragOver={handleDragOver}
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onClick={handleClick}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}>
      {file ? (
        <Box sx={styles.uploadContainer}>
          <UploadFileIcon sx={styles.uploadIcon} />
          <Typography>
            {t('uploader_container.image_selected')} {file.name}
          </Typography>
        </Box>
      ) : (
        <Box sx={styles.uploadContainer}>
          <UploadFileIcon sx={styles.uploadIcon} />
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Typography sx={styles.uploadText}>{t('uploader_container.click_upload')}</Typography>
            <Typography>{t('uploader_container.drag_drop')}</Typography>
          </Box>
          <Typography sx={styles.warningText}>{t('uploader_container.warning')}</Typography>
        </Box>
      )}
      <input type="file" ref={fileInputRef} style={{ display: 'none' }} onChange={handleFileChange} accept="image/*" />
    </div>
  );
};

export default UploaderContainer;
